import { useLocation } from 'react-router-dom'
import {
  BackCircleButton,
  getDetailBackButtonFallback,
} from '../back-circle-button'

type PageTitlePrefixSlotProps = {
  className?: string
  fallbackPath?: string
}

export const PageTitlePrefixSlot = ({
  className,
  fallbackPath,
}: PageTitlePrefixSlotProps) => {
  const { pathname } = useLocation()
  const resolvedFallback = fallbackPath ?? getDetailBackButtonFallback(pathname)

  if (!resolvedFallback) {
    return null
  }

  return (
    <BackCircleButton fallbackPath={resolvedFallback} className={className} />
  )
}
